<template>
  <b-modal ref="modal" title="⏸ Kechiktirilgan savdolar" size="lg" hide-footer centered @shown="onShown">
    <!-- Qidiruv -->
    <div class="mb-3">
      <input
        ref="search"
        v-model="search"
        type="text"
        class="form-control"
        placeholder="🔍 Mijoz, mashina raqami yoki izoh bo'yicha qidirish..."
      >
    </div>

    <div v-if="loading" class="text-center py-4">
      <span class="spinner-border"></span>
    </div>

    <div v-else-if="filteredList.length === 0" class="text-center py-5 text-muted">
      <div style="font-size:2.2rem">🗒️</div>
      <p class="mb-0 mt-2">Kechiktirilgan savdo yo'q</p>
    </div>

    <div v-else class="parked-list">
      <div v-for="p in filteredList" :key="p.id" class="parked-row">
        <div class="parked-main">
          <div class="parked-top">
            <span class="parked-id">#{{ p.id }}</span>
            <span class="parked-client">{{ p.kontragent ? p.kontragent.name : "Noma'lum mijoz" }}</span>
            <span v-if="p.master" class="parked-master">🔧 {{ p.master.name }}</span>
          </div>
          <div class="parked-sub">
            <span v-if="p.car_number" class="parked-chip">🚗 {{ p.car_number }}</span>
            <span class="parked-chip">🕒 {{ formatTime(p.created_at) }}</span>
            <span v-if="p.comment" class="parked-chip parked-comment">💬 {{ p.comment }}</span>
          </div>
        </div>
        <div class="parked-side">
          <div class="parked-summa">{{ formatSumma(p.summa) }} so'm</div>
          <div class="parked-actions">
            <button class="btn btn-sm btn-success" :disabled="busyId === p.id" @click="$emit('resume', p.id)">
              Davom ettirish
            </button>
            <button class="btn btn-sm btn-outline-danger" :disabled="busyId === p.id" @click="$emit('delete', p.id)">
              O'chirish
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ParkedSalesModal',
  props: {
    list:    { type: Array,   default: () => [] },
    loading: { type: Boolean, default: false },
    busyId:  { default: null },
  },
  emits: ['resume', 'delete'],
  data() {
    return { search: '' };
  },
  computed: {
    filteredList() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.list;
      return this.list.filter((p) => {
        const name = (p.kontragent && p.kontragent.name) || '';
        const master = (p.master && p.master.name) || '';
        const car = p.car_number || '';
        const comment = p.comment || '';
        return (
          String(p.id).includes(q) ||
          name.toLowerCase().includes(q) ||
          master.toLowerCase().includes(q) ||
          car.toLowerCase().includes(q) ||
          comment.toLowerCase().includes(q)
        );
      });
    },
  },
  methods: {
    show() { this.$refs.modal.show(); },
    hide() { this.$refs.modal.hide(); },
    onShown() {
      this.search = '';
      this.$nextTick(() => { if (this.$refs.search) this.$refs.search.focus(); });
    },
    formatSumma(s) { return Number(s || 0).toLocaleString(); },
    formatTime(ts) {
      if (!ts) return '';
      const d = new Date(Number(ts) * 1000);
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d.getDate())}.${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
  },
};
</script>

<style scoped>
.parked-list {
  max-height: 60vh;
  overflow-y: auto;
}
.parked-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-left: 3px solid #f59e0b;
  border-radius: 12px;
  padding: 10px 14px;
  margin-bottom: 8px;
}
.parked-top {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.parked-id {
  font-weight: 800;
  color: #b45309;
}
.parked-client {
  font-weight: 700;
  color: #1e293b;
}
.parked-master {
  font-size: 0.78rem;
  color: #0ea5e9;
  font-weight: 600;
}
.parked-sub {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.parked-chip {
  font-size: 0.72rem;
  color: #64748b;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 2px 8px;
}
.parked-comment {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.parked-side {
  text-align: right;
  flex-shrink: 0;
}
.parked-summa {
  font-weight: 800;
  color: #059669;
  margin-bottom: 6px;
  white-space: nowrap;
}
.parked-actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
</style>
